import * as bootstrap from "./bootstrap"
window.bootstrap = bootstrap;